module.exports = __webpack_public_path__ + "img/Logout-white.b870569a.svg";